module.exports = __webpack_public_path__ + "img/louis-hero-home.43fb3c13.jpg";